import { render, staticRenderFns } from "./phoneNav.vue?vue&type=template&id=192d8e19&scoped=true"
import script from "./phoneNav.vue?vue&type=script&lang=js"
export * from "./phoneNav.vue?vue&type=script&lang=js"
import style0 from "./phoneNav.vue?vue&type=style&index=0&id=192d8e19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192d8e19",
  null
  
)

export default component.exports